export default "__VITE_ASSET__Crg7UP$i__"